import { FC } from 'react';

import { ColorPalette, IconType } from '../../../types';
import Icon from '../../Icon';

export type StateItemType = 'error-line' | 'error-solid' | 'fatal' | 'info' | 'help' | 'check-solid';

export interface StateItemProps {
  type: StateItemType;
  className?: string;
}

const convertStateItemType = (itemType: StateItemType): IconType => {
  switch (itemType) {
    case 'error-solid':
      return 'state-error-solid';
    case 'fatal':
      return 'state-fatal';
    case 'info':
      return 'state-info';
    case 'help':
      return 'state-help';
    case 'check-solid':
      return 'check-solid';
    default:
      return 'state-error-line';
  }
};

const matchedItemColor = (itemType: StateItemType): ColorPalette => {
  switch (itemType) {
    case 'error-line':
      return 'orange.600';
    case 'error-solid':
      return 'orange.600';
    case 'fatal':
      return 'red.600';
    case 'check-solid':
      return 'green.600';
    default:
      return 'gray.600';
  }
};

const StateItem: FC<React.PropsWithChildren<React.PropsWithChildren<StateItemProps>>> = ({ type = 'error-line', className }) => {
  return <Icon type={convertStateItemType(type)} color={matchedItemColor(type)} size={20} className={className} />;
};

export default StateItem;
